import React from 'react';
import { Spinner, Table, Nav } from 'react-bootstrap';
import { Pagination } from '~/components/Pagination';
import { PaginationType, emptyPagination, useServiceSubscribe } from '~/util';
import { BannerType, useAdminService } from '~/services';
import { BannerRow } from '~/components/Admin';

export function ListBanners() {
    const [loading, setLoading] = React.useState(false);
    const [list, setList] = React.useState<BannerType[]>([]);
    const [searchExpired, setSearchExpired] = React.useState(false);
    const paginationRef = React.useRef(emptyPagination());
    const { getBanners, events } = useAdminService();

    const loadBanners = React.useCallback(async () => {
        setLoading(true);
        const { results, pagination } = await getBanners({
            is_expired: searchExpired,
            page: paginationRef.current.current,
            items_per_page: paginationRef.current.items_per_page,
        });
        setList(results);
        paginationRef.current = pagination;
        setLoading(false);
    }, [getBanners, searchExpired]);

    useServiceSubscribe(events.banner_list_updated, loadBanners);

    function updatePagination(pagination: PaginationType) {
        paginationRef.current = { ...pagination };
        loadBanners();
    }

    React.useEffect(() => {
        loadBanners();
    }, [loadBanners]);

    return (
        <div className="card">
            <div className="card-header">
                <Nav variant="tabs" className="card-header-tabs">
                    <Nav.Item>
                        <Nav.Link
                            className={!searchExpired ? 'active' : undefined}
                            onClick={() => setSearchExpired(false)}
                        >
                            Active
                        </Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                        <Nav.Link
                            className={searchExpired ? 'active' : undefined}
                            onClick={() => setSearchExpired(true)}
                        >
                            Expired
                        </Nav.Link>
                    </Nav.Item>
                </Nav>
            </div>
            <div className="card-body">
                <div className="table-scroll">
                    <Table striped bordered hover>
                        <thead className="table-dark">
                            <tr>
                                <th>Start Date</th>
                                <th>End Date</th>
                                <th className="w-50">Banner Message</th>
                                <th>
                                    <span className="sr-only">Actions</span>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {loading && (
                                <tr>
                                    <td colSpan={4} className="text-center bg-white">
                                        <Spinner animation="border">
                                            <span className="sr-only">Loading Banners</span>
                                        </Spinner>
                                    </td>
                                </tr>
                            )}
                            {list.map((x) => (
                                <BannerRow key={x.id} banner={x} />
                            ))}
                        </tbody>
                    </Table>
                </div>
                <Pagination
                    pagination={paginationRef.current}
                    updatePagination={updatePagination}
                />
            </div>
        </div>
    );
}
